<template>
  <div id="form-event">
    <h2>
      <span v-if="editingMode === 'edit'">Editar</span>
      <span v-if="editingMode === 'create'">Novo</span> Evento
    </h2>
    <br />
    <b-container>
      <b-row>
        <b-col sm="4">
          <b-input-group prepend="Categoria" size="sm" class="mt-4">
            <b-form-select
              v-model="editingCache.category"
              :options="EventCategories"
              v-validate.initial="'required'"
              :disabled="disabledInputs"
              name="category"
            ></b-form-select>
          </b-input-group>
          <b-form-invalid-feedback
            :state="errors.collect('category').length === 0"
          >{{errors.first('category')}}</b-form-invalid-feedback>
        </b-col>
        <b-col sm="8">
          <b-input-group prepend="Imagem" size="sm" class="mt-4">
            <b-form-input
              v-model="editingCache.image"
              v-validate.initial="'max:100'"
              type="text"
              name="image"
              size="sm"
              :disabled="disabledInputs"
            />
          </b-input-group>
        </b-col>
        <b-col :style="{display: 'none'}" sm="4">
          <b-input-group style="margin-top:6%;">
            <b-input-group-prepend is-text>
              <b-form-checkbox
                v-model="editingCache.isFav"
                v-validate.initial="'required'"
                type="text"
                name="isFav"
                :disabled="disabledInputs"
              />
            </b-input-group-prepend>
            <b-form-input placeholder="Favorito" aria-label="Text input with checkbox"></b-form-input>
          </b-input-group>
          <b-form-invalid-feedback
            :state="errors.collect('isFav').length === 0"
          >{{errors.first('isFav')}}</b-form-invalid-feedback>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="4">
          <b-input-group prepend="Page Type" size="sm" class="mt-4">
            <b-form-select
              v-model="editingCache.pageType"
              :options="EventPageTypes"
              v-validate.initial="'required'"
              :disabled="disabledInputs"
              name="pageType"
            ></b-form-select>
          </b-input-group>
          <b-form-invalid-feedback
            :state="errors.collect('pageType').length === 0"
          >{{errors.first('pageType')}}</b-form-invalid-feedback>
        </b-col>
        <b-col sm="4">
          <b-input-group prepend="Data Inicio" size="sm" class="mt-4">
            <b-form-input
              v-model="editingCache.date"
              v-validate.initial="'required|max:10'"
              type="date"
              name="date"
              size="sm"
              :disabled="disabledInputs"
            />
          </b-input-group>
          <b-form-invalid-feedback
            :state="errors.collect('date').length === 0"
          >{{errors.first('date')}}</b-form-invalid-feedback>
        </b-col>
        <b-col sm="4">
          <b-input-group prepend="Data Fim" size="sm" class="mt-4">
            <b-form-input
              v-model="editingCache.dateEnding"
              v-validate.initial="'required|max:10'"
              type="date"
              name="dateEnding"
              size="sm"
              :disabled="disabledInputs"
            />
          </b-input-group>
          <b-form-invalid-feedback
            :state="errors.collect('dateEnding').length === 0"
          >{{errors.first('dateEnding')}}</b-form-invalid-feedback>
        </b-col>
      </b-row>
      <b-row :style="{display: 'none'}">
        <b-col sm="4">
          <b-input-group prepend="Morada" size="sm" class="mt-4">
            <b-form-input
              value="a"
              type="text"
              name="address"
              size="sm"
              :disabled="disabledInputs"
            />
          </b-input-group>
          <b-form-invalid-feedback
            :state="errors.collect('address').length === 0"
          >{{errors.first('address')}}</b-form-invalid-feedback>
        </b-col>
        <b-col sm="4">
          <b-input-group prepend="Info Morada" size="sm" class="mt-4">
            <b-form-input
              value="."
              type="text"
              name="addressInfo"
              size="sm"
              :disabled="disabledInputs"
            />
          </b-input-group>
          <b-form-invalid-feedback
            :state="errors.collect('addressInfo').length === 0"
          >{{errors.first('addressInfo')}}</b-form-invalid-feedback>
        </b-col>
        <b-col sm="4">
          <b-input-group prepend="Telefone" size="sm" class="mt-4">
            <b-form-input value="." type="text" name="phone" size="sm" :disabled="disabledInputs" />
          </b-input-group>
          <b-form-invalid-feedback
            :state="errors.collect('phone').length === 0"
          >{{errors.first('phone')}}</b-form-invalid-feedback>
        </b-col>
      </b-row>
      <b-row :style="{display: 'none'}">
        <b-col sm="4">
          <b-input-group prepend="Horario" size="sm" class="mt-4">
            <b-form-input value="." type="text" name="time" size="sm" :disabled="disabledInputs" />
          </b-input-group>
          <b-form-invalid-feedback
            :state="errors.collect('time').length === 0"
          >{{errors.first('time')}}</b-form-invalid-feedback>
        </b-col>
        <b-col sm="4">
          <b-input-group prepend="Tab" size="sm" class="mt-4">
            <b-form-input
              value="1"
              type="range"
              min="1"
              max="4"
              name="isPnch"
              size="sm"
              :disabled="disabledInputs"
            />
            <div class="mt-2">&nbsp; {{ editingCache.isPnch }}</div>
          </b-input-group>
          <b-form-invalid-feedback
            :state="errors.collect('isPnch').length === 0"
          >{{errors.first('isPnch')}}</b-form-invalid-feedback>
        </b-col>
      </b-row>
      <b-row>
        <b-tabs class="mt-4 w-100">
          <b-tab title="Português">
            <translations-event
              v-bind.sync="editingCache"
              :disabledInputs="disabledInputs"
              language="pt"
            />
          </b-tab>
          <b-tab title="Inglês">
            <translations-event
              v-bind.sync="editingCache"
              :disabledInputs="disabledInputs"
              language="en"
            />
          </b-tab>
          <b-tab title="Francês">
            <translations-event
              v-bind.sync="editingCache"
              :disabledInputs="disabledInputs"
              language="fr"
            />
          </b-tab>
          <b-tab title="Espanhol">
            <translations-event
              v-bind.sync="editingCache"
              :disabledInputs="disabledInputs"
              language="es"
            />
          </b-tab>
        </b-tabs>
      </b-row>
    </b-container>
    <br />
    <div v-if="editingMode !== 'view'">
      <b-button
        variant="primary"
        @click="editingMode === 'edit' ? updateEvent(editingCache.id) : createEvent()"
        :disabled="errors.count() > 0"
      >Submeter</b-button>
    </div>
  </div>
</template>

<script>
import api from "../../api";
import { mapMutations, mapActions, mapGetters } from "vuex";
import translationsEvent from "./translationsEvent";
export default {
  name: "formEvent",
  props: {
    editingMode: { type: String, required: true },
    event: { type: Object }
  },
  components: {
    translationsEvent
  },
  data() {
    return {
      editingCache: {
        title: "",
        category: "",
        image: "",
        pageType: "",
        date: "",
        dateEnding: "",
        address: "",
        addressInfo: "",
        phone: "",
        time: "",
        isFav: false,
        isPnch: 1,
        subTitle: "",
        description: "",
        boldDesc: "",
        translations: {
          pt: {
            title: "",
            bold_desc: "",
            description: ""
          },
          en: {
            title: "",
            bold_desc: "",
            description: ""
          },
          fr: {
            title: "",
            bold_desc: "",
            description: ""
          },
          es: {
            title: "",
            bold_desc: "",
            description: ""
          }
        }
      }
    };
  },
  computed: {
    ...mapGetters(["EventPageTypes", "EventCategories"]),
    disabledInputs() {
      return this.editingMode === "view";
    }
  },
  mounted() {
    if (this.editingMode !== "create") {
      this.editingCache = JSON.parse(JSON.stringify(this.event));
    }
    this.fetchAutoCompletes();
  },
  methods: {
    ...mapMutations(["showNotice"]),
    ...mapActions(["refreshEvents", "fetchAutoCompletes"]),
    createEvent() {
      api.newEvent(this.editingCache).then(() => {
        this.refreshEvents();
        this.showNotice({ newMessage: "Evento criado", type: "success" });
      });
    },
    updateEvent(id) {
      api.updateEvent({ id: id }, this.editingCache).then(() => {
        this.refreshEvents();
        this.showNotice({ newMessage: "Evento atualizado", type: "success" });
      });
    }
  }
};
</script>

<style lang='css'>
#new-event {
  color: #56b983;
}
#new-event label {
  text-align: left;
}
.errors-list {
  color: red;
  list-style-type: none;
}
</style>
